import { authorsDropdownModule } from '@/pages/dictionary/themes/list/parts/themes-filter/parts/authors-dropdown/authors-dropdown.model'
import { classesDropdownModule } from '@/pages/common/dropdowns/class/classes-dropdown.model'
import { subjectsDropdownModel } from '@/pages/common/dropdowns/subject/subjects-dropdown.model'

export const dropdownModules = {
  authorsDropdownModule,
  classesDropdownModule,
  subjectsDropdownModel,
}
